import { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import {
  collection,
  query,
  where,
  getDocs,
  doc,
  getDoc
} from "firebase/firestore";

import { auth, db } from "../Config/firebase";
import { consultaTenantAtual } from "../Utils/tenant";
import { salvarRespostaKPI } from "../../services/kpiRespostasService";
import {
  getCycleMeta,
  getCycleMetaFromResposta,
  isDateWithinCycle,
  normalizePeriodicidade,
} from "./ciclo.utils";
import {
  opcoesPsicossocial as opcoesPsicossocialPadrao,
  VERSAO_PONTUACAO_PSICOSSOCIAL,
} from "../Psicossocial/psicossocialUtils";
import "./KPIFormGeral.css";

function getCodigoPergunta(pergunta) {
  return String(pergunta.codigo || "").trim().toUpperCase();
}

function opcoesPsicossocial(codigo) {
  const c = String(codigo || "").trim().toUpperCase();

  // 1B tem pontuação invertida no formulário
  if (c === "1B") {
    return [
       { label: "Nunca", valor: 4 },
       { label: "Raramente", valor: 3 },
       { label: "Às vezes", valor: 2 },
       { label: "Frequentemente", valor: 1 },
      { label: "Sempre", valor: 0 },   
            
     
    ];
  }

  // 1A, 2A, 2B, 3A, 3B, 12A, 12B, 18A, 18B, 19A, 19B
  if (
    [
      "1A",
      "2A",
      "2B",
      "3A",
      "3B",
      "12A",
      "12B",
      "18A",
      "18B",
      "19A",
      "19B",
    ].includes(c)
  ) {
    return [
      { label: "Sempre", valor: 4 },
      { label: "Frequentemente", valor: 3 },
      { label: "Às vezes", valor: 2 },
      { label: "Raramente", valor: 1 },
      { label: "Nunca", valor: 0 },
    ];
  }

  // 4A até 11B e 15A até 16B
  if (
    [
      "4A",
      "4B",
      "5A",
      "5B",
      "6A",
      "6B",
      "7A",
      "7B",
      "8A",
      "8B",
      "9A",
      "9B",
      "10A",
      "10B",
      "11A",
      "11B",
      "15A",
      "15B",
      "16A",
      "16B",
    ].includes(c)
  ) {
    return [
      { label: "Em grande parte", valor: 4 },
      { label: "Em boa parte", valor: 3 },
      { label: "De certa forma", valor: 2 },
      { label: "Pouco", valor: 1 },
      { label: "Muito pouco", valor: 0 },
    ];
  }

  // 13
  if (c === "13") {
    return [
      { label: "Muito satisfeito", valor: 3 },
      { label: "Satisfeito", valor: 2 },
      { label: "Insatisfeito", valor: 1 },
      { label: "Muito insatisfeito", valor: 0 },
    ];
  }

  // 14A e 14B
  if (["14A", "14B"].includes(c)) {
    return [
      { label: "Sim, com certeza", valor: 3 },
      { label: "Sim, até certo ponto", valor: 2 },
      { label: "Sim, mas muito pouco", valor: 1 },
      { label: "Não, realmente não", valor: 0 },
    ];
  }

  // 17
  if (c === "17") {
    return [
      { label: "Excelente", valor: 4 },
      { label: "Muito boa", valor: 3 },
      { label: "Boa", valor: 2 },
      { label: "Razoável", valor: 1 },
      { label: "Ruim", valor: 0 },
    ];
  }

  // 20 a 23
  if (["20", "21", "22", "23"].includes(c)) {
    return [
      { label: "Sim, diariamente", valor: 1 },
      { label: "Sim, semanalmente", valor: 1 },
      { label: "Sim, mensalmente", valor: 1 },
      { label: "Sim, poucas vezes", valor: 1 },
      { label: "Não", valor: 0 },
    ];
  }

  return [];
}

function getOpcoesPergunta(pergunta, kpi) {
  if (kpi?.tipoFormulario === "PSICOSSOCIAL") {
    const opcoesPadronizadas = opcoesPsicossocialPadrao(
      getCodigoPergunta(pergunta)
    );

    if (opcoesPadronizadas.length > 0) {
      return opcoesPadronizadas;
    }
  }

  if (Array.isArray(pergunta.opcoes) && pergunta.opcoes.length > 0) {
    return pergunta.opcoes;
  }

  return [];
}

function respostaPertenceAoCiclo(resposta, kpi, cicloAtual) {
  if (resposta.ciclo === cicloAtual.chave) return true;
  if (isDateWithinCycle(resposta.createdAt, cicloAtual)) return true;

  const cicloResposta = getCycleMetaFromResposta({
    createdAt: resposta.createdAt,
    ciclo: resposta.ciclo,
    ano: resposta.ano,
    cicloNumero: resposta.cicloNumero ?? resposta.trimestre,
    periodicidade: kpi.periodicidadeCiclos ?? resposta.periodicidadeCiclos,
  });

  return (
    cicloResposta.ano === cicloAtual.ano &&
    cicloResposta.cicloNumero === cicloAtual.cicloNumero
  );
}

function KPIFormGeral() {
  const { kpiId } = useParams();
  const history = useHistory();

  const tipoUsuario =
    (localStorage.getItem("tipoUsuario") || "cliente").toLowerCase();

    function voltarParaTelaAnterior() {
  history.goBack();
}

  function voltarParaHome() {
  if (tipoUsuario === "admin") {
    history.push("/dashboard");
  } else if (tipoUsuario === "colaborador") {
    history.push("/app/cadastromateriais");
  } else if (tipoUsuario === "cliente") {
    history.push("/app/laudos");
  } else {
    history.push("/");
  }
}


  const [kpi, setKpi] = useState(null);
  const [perguntas, setPerguntas] = useState([]);
  const [respostas, setRespostas] = useState({});
  const [loading, setLoading] = useState(true);
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState(null);
  const [popupBloqueado, setPopupBloqueado] = useState(false);
  const [popupSucesso, setPopupSucesso] = useState(false);

  useEffect(() => {
    carregar();
    // eslint-disable-next-line
  }, [kpiId]);

  async function carregar() {
    try {
      setLoading(true);
      setErro(null);

      const kpiSnap = await getDoc(doc(db, "kpis", kpiId));
      if (!kpiSnap.exists() || !kpiSnap.data().ativo) {
        setErro("Pesquisa não encontrada");
        return;
      }

      const kpiData = { id: kpiSnap.id, ...kpiSnap.data() };
      const periodicidadeCiclos = normalizePeriodicidade(kpiData.periodicidadeCiclos);
      const cicloAtual = getCycleMeta(new Date(), periodicidadeCiclos);
         
    
          // 🔐 VALIDAR ESCOPO DO KPI
            if (kpiData.escopo) {
              const escopoUsuario =
                tipoUsuario === "admin" ? "colaborador" : tipoUsuario;

            if (kpiData.escopo !== escopoUsuario) {
              setErro("Você não tem permissão para responder este indicador.");
              return;
            }
          }



          // 🔴 BLOQUEAR KPI DE EVENTO
          if (kpiData.tipoKPI === "EVENTO") {
            setErro("Este indicador não é uma pesquisa.");
            return;
          }

          setKpi(kpiData);


      if (kpiData.tipoFormulario !== "PSICOSSOCIAL") {
  const respSnap = await getDocs(
    query(
      collection(db, "kpi_respostas"),
      where("kpiId", "==", kpiData.id),
      where("userId", "==", auth.currentUser.uid)
    )
  );

  const jaRespondeuNoCiclo = respSnap.docs.some((item) =>
    respostaPertenceAoCiclo(item.data(), kpiData, cicloAtual)
  );

  if (jaRespondeuNoCiclo) {
    setPopupBloqueado(true);
    return;
  }
}

      /* =========================
         🔽 PERGUNTAS ORDENADAS
      ========================= */
      const perguntasSnap = await getDocs(
        consultaTenantAtual(collection(db, "kpi_perguntas"))
      );

      const lista = perguntasSnap.docs
        .map(d => ({ id: d.id, ...d.data() }))
        .filter(pergunta => pergunta.kpiId === kpiData.id && pergunta.ativa === true)
        .sort((a, b) => Number(a.ordem || 0) - Number(b.ordem || 0));

      setPerguntas(lista);
    } catch (e) {
      console.error(e);
      setErro("Erro ao carregar pesquisa");
    } finally {
      setLoading(false);
    }
  }

  function responder(id, valor) {
    setRespostas(prev => ({ ...prev, [id]: valor }));
  }

  async function enviar() {
    setErro(null);

  for (let p of perguntas) {
  const opcoes = getOpcoesPergunta(p, kpi);
  const temOpcoes = opcoes.length > 0;

  if (
    (temOpcoes && respostas[p.id] === undefined) ||
    (p.tipo === "texto" && (!respostas[p.id] || !respostas[p.id].trim()))
  ) {
    setErro("Para uma pesquisa mais eficiente, responda todas as perguntas.");
    return;
  }
}

    let obtida = 0;
    let maxima = 0;

    perguntas.forEach(p => {
  const opcoes = getOpcoesPergunta(p, kpi);
  if (!opcoes.length) return;

  const r = Number(respostas[p.id]);
  const peso = Number(p.peso || 1);

  if (Number.isFinite(r)) {
    obtida += r * peso;
    maxima += Math.max(...opcoes.map(o => Number(o.valor || 0))) * peso;
  }
});

    const indice = maxima ? Number(((obtida / maxima) * 100).toFixed(2)) : 0;
    const periodicidadeCiclos = normalizePeriodicidade(kpi?.periodicidadeCiclos);
    const cicloAtual = getCycleMeta(new Date(), periodicidadeCiclos);
// 🔹 BUSCAR OBRA DO USUÁRIO (CLIENTE)
let obraId = null;
let obraNome = null;

try {
  const userSnap = await getDoc(doc(db, "users", auth.currentUser.uid));
  if (userSnap.exists()) {
    const userData = userSnap.data();

    if (Array.isArray(userData.obras) && userData.obras.length > 0) {
      obraId = userData.obras[0];

      const obraSnap = await getDoc(doc(db, "obras", obraId));
      if (obraSnap.exists()) {
        obraNome = obraSnap.data().nome;
      }
    }
  }
} catch (e) {
  console.error("Erro ao resolver obra do usuário", e);
}



    try {
      setEnviando(true);
const respostasPorCodigo = {};

perguntas.forEach((p) => {
  const codigo = getCodigoPergunta(p) || p.id;
  respostasPorCodigo[codigo] = respostas[p.id];
});
      await salvarRespostaKPI({
  kpiId: kpi.id,
  ...(kpi.tipoFormulario === "PSICOSSOCIAL"
    ? {
         tipoFormulario: "PSICOSSOCIAL",
         anonima: true,
         versaoPontuacaoPsicossocial: VERSAO_PONTUACAO_PSICOSSOCIAL,
      }
    : {
        userId: auth.currentUser.uid,
        tipoFormulario: kpi.tipoFormulario || "GERAL",
        obraId,
        obraNome,
      }),

  respostas: respostasPorCodigo,
  pontuacaoObtida: obtida,
  pontuacaoMaxima: maxima,
  indice,

  ciclo: cicloAtual.chave,
  cicloLabel: cicloAtual.rotulo,
  ano: cicloAtual.ano,
  cicloNumero: cicloAtual.cicloNumero,
  trimestre: periodicidadeCiclos === 4 ? cicloAtual.cicloNumero : null,
  periodicidadeCiclos
});


      setPopupSucesso(true);
    } catch (e) {
      console.error(e);
      setErro("Erro ao enviar respostas");
    } finally {
      setEnviando(false);
    }
  }

  if (loading) return null;

  return (
    <>
      {/* POPUP BLOQUEADO */}
      {popupBloqueado && (
        <div className="modal fade show" style={{ display: "block", background: "rgba(0,0,0,.5)" }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title text-success">Pesquisa já respondida</h5>
                <button className="btn-close" onClick={voltarParaTelaAnterior} />
              </div>
              <div className="modal-body text-center">
                Você já respondeu esta pesquisa neste ciclo.
              </div>
              <div className="modal-footer justify-content-center">
                <button className="btn btn-success" onClick={voltarParaTelaAnterior}>OK</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* FORMULÁRIO */}
      {!popupBloqueado && !popupSucesso && (
        <div className="modal fade show" style={{ display: "block", background: "rgba(0,0,0,.5)" }}>
          <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">

              <div className="modal-header">
                <h5 className="modal-title">{kpi?.nome}</h5>
                <button className="btn-close" onClick={voltarParaHome} />
              </div>

              <div className="modal-body">
                <p className="text-muted">{kpi?.descricao}</p>

                {perguntas.map((p, idx) => {
  const opcoes = getOpcoesPergunta(p, kpi);
  const codigo = getCodigoPergunta(p);

  return (
    <div key={p.id} className="mb-4">
      <strong>
        {idx + 1}. {p.texto}
      </strong>

      {opcoes.length > 0 && (
        <div className="mt-2 border rounded overflow-hidden">
          <div className="row g-0">
            {opcoes.map((op, opIndex) => (
              <label
                key={`${codigo}-${opIndex}`}
                className="col border-end p-2 text-center d-flex justify-content-center align-items-center gap-1"
                style={{
                  cursor: "pointer",
                  background:
                    respostas[p.id] === op.valor
                      ? "#e7f1ff"
                      : "#fff",
                }}
              >
                <input
                  className="form-check-input me-1"
                  type="radio"
                  name={p.id}
                  checked={respostas[p.id] === op.valor}
                  onChange={() => responder(p.id, op.valor)}
                />
                <span style={{ fontSize: 13, whiteSpace: "nowrap" }}>
  {op.label} ({op.valor})
</span>
              </label>
            ))}
          </div>
        </div>
      )}

      {p.tipo === "texto" && (
        <textarea
          className="form-control mt-2"
          rows={3}
          value={respostas[p.id] || ""}
          onChange={e => responder(p.id, e.target.value)}
        />
      )}
    </div>
  );
})}
              </div>

              <div className="modal-footer flex-column align-items-stretch">
                {erro && <div className="alert alert-danger w-100">{erro}</div>}
                <div className="d-flex justify-content-end gap-2">
                  <button className="btn btn-secondary" onClick={voltarParaHome}>
                    Cancelar
                  </button>
                  <button className="btn btn-success" onClick={enviar} disabled={enviando}>
                    {enviando ? "Enviando..." : "Enviar Pesquisa"}
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
      )}

    {/* SUCESSO */}
          {popupSucesso && (
            <div
              className="modal fade show"
              style={{ display: "block", background: "rgba(0,0,0,.5)" }}
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-body text-center">
                    <h5 className="text-success mb-3">
                      Obrigado por responder a pesquisa!
                    </h5>

                    <button
                      className="btn btn-success"
                      onClick={voltarParaTelaAnterior}
                    >
                      OK
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

        </>
  );
}

export default KPIFormGeral;
